module.exports = __webpack_public_path__ + "img/push_up_button.43a26793.jpg";